import * as React from 'react';
import { Segment, Divider, Header } from 'semantic-ui-react';
import { ButtonLarge } from 'theme';

export interface ISubscriptionItemProps {
    title: string;
    bestValue: boolean;
    monthlyPrice: number;
    dueToday: number;
    info: string;
    buttonText: string;
    onSubscribe();
}

export const SubscriptionItem: React.SFC<ISubscriptionItemProps> = ({ title, bestValue, monthlyPrice, dueToday, info, onSubscribe, buttonText }) => {
    return (
        <Segment className="plans__plan-segment" raised>
            {bestValue && <div className="plans__best-value text-bold background-red color-white">BEST VALUE</div>}
            <Header className="plans__title-text" as="h2">{title}</Header>
            <div className="text-small">SUBSCRIPTION</div>
            <Divider />
            <Header as="h1" className="plans__monthly-price-header">${monthlyPrice}/month</Header>
            <Header as="h3" className="plans__due-today-header warn">${dueToday} due today</Header>
            <p className="plans__info-text text-small">{info}</p>
            <p className="plans__regular-updates-text text-small">Regular updates with new features</p>
            <p className="plans__free-app-text text-small">FREE app usage in all available languages for entirety of beta period</p>
            <ButtonLarge className="plans__button text-medium" onClick={onSubscribe}>{buttonText}</ButtonLarge>
        </Segment>
    )
}



// WEBPACK FOOTER //
// ./src/components/presentational/controls/SubscriptionPlanItem/index.tsx